import CommunicationsMessageControllerBase from 'garaje/helpers/communications/message-log/show/controller-base';

export default class CommunicationsMessageController extends CommunicationsMessageControllerBase {}
